module.exports = __webpack_public_path__ + "img/language.9c5fe2cf.svg";